
import { mapState } from 'vuex'
import { authorImage } from '@/utils/constants'

import HeroButton from '@/components/HeroButton'
import OverlayContainer from '@/components/OverlayContainer'
import RecommendationCarousel from '@/components/RecommendationCarousel'

export default {
  components: {
    HeroButton,
    OverlayContainer,
    RecommendationCarousel,
  },
  props: {
    displayModalDialog: {
      type: Boolean,
      default: false,
    },
    recommendations: {
      type: Array,
      default: () => [],
    },
    productUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      authorImage,
    }
  },
  computed: {
    ...mapState(['cdn']),
  },
  watch: {
    displayModalDialog() {
      if (this.displayModalDialog) return this.openModalOverlay()
      this.closeModalOverlay()
    },
  },
  methods: {
    primaryClicked() {
      this.$emit('primary-clicked')
    },
    openModalOverlay() {
      this.$refs.modalContainer.open()
      const data = {
        event: 'upsellCampaign',
        displayLocation: this.productUrl,
      }
      this.$gtm.push(data)
    },
    closeModalOverlay() {
      this.$refs.modalContainer.close()
    },
    addRecommendedToBasket(item) {
      this.$emit('added-to-basket', item, 'upsellCampaign')
    },
  },
}
